import React, { AnchorHTMLAttributes, MouseEvent } from 'react';

const jump = (event: MouseEvent<HTMLAnchorElement>, offset: number = 0) => {
  event.preventDefault();
  const id = (event.target as HTMLAnchorElement).hash.replace('#', '');
  const el = document.getElementById(id);
  if (el) {
    window.scrollTo(0, el.offsetTop + offset);
  }
};

const JumpLink: React.FC<AnchorHTMLAttributes<HTMLAnchorElement> & { offset?: number }> = (props) => (
  <a {...props} onClick={(event) => jump(event, props.offset)} />
);

export default JumpLink;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/JumpLink.tsx